// src/redux/store.ts
import { Action, configureStore } from "@reduxjs/toolkit";
import thunk, { ThunkAction } from "redux-thunk";
import rootReducer from "./slices";
import { loadState, saveState, throttle } from "./localStorage";

type RootReducerState = ReturnType<typeof rootReducer>;

function selectPersistedState(
  state: RootReducerState
): Partial<RootReducerState> {
  return state; // you wanted to persist all slices
}

const preloadedState =
  typeof window !== "undefined"
    ? loadState<Partial<RootReducerState>>()
    : undefined;

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
  preloadedState: preloadedState as any,
});

// Subscribe only in the browser to avoid SSR touching timers/localStorage
if (typeof window !== "undefined") {
  store.subscribe(
    throttle(() => {
      const state = store.getState() as RootReducerState;
      saveState(selectPersistedState(state));
    }, 750)
  );
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
